document.addEventListener('DOMContentLoaded', function () {
  const accordionHeaders = document.querySelectorAll('.js-accordion-header');

  // Open first accordion by default
  const firstContent = document.querySelector('.js-accordion-content[data-index="1"]');
  const firstHeader = document.querySelector('.js-accordion-header[data-index="1"]');

  if (firstContent && firstHeader) {
    firstContent.classList.add('active');
    firstHeader.classList.add('active');
  }

  accordionHeaders.forEach(header => {
    header.addEventListener('click', function () {
      const content = document.querySelector(`.js-accordion-content[data-index="${this.dataset.index}"]`);
      const isActive = this.classList.contains('active');

      // Close all sections
      accordionHeaders.forEach(h => {
        h.classList.remove('active');
      });

      document.querySelectorAll('.js-accordion-content').forEach(c => {
        c.classList.remove('active');
      });

      // If the clicked section wasn't active before, open it
      if (!isActive) {
        this.classList.add('active');
        content.classList.add('active');
      }
    });
  });
});